import {css} from '@emotion/react';
import styled from '@emotion/styled';

export const ControlsContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  justify-content: center;

  ${({theme}) =>
    theme.respondTo(
      'xl',
      css`
        flex-direction: row;
      `
    )};
`;
